import script from "./DailyBookingBarChart.vue?vue&type=script&setup=true&lang=js"
export * from "./DailyBookingBarChart.vue?vue&type=script&setup=true&lang=js"

import "./DailyBookingBarChart.vue?vue&type=style&index=0&id=c2c8a358&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2c8a358"]])

export default __exports__